module.exports = __webpack_public_path__ + "images/sprites/ui/price_balloon_bg_218a400aac179b316c94f04d2525feda.png";